import { processEmailHtml } from './email-html';

/** Plaintext remains separate from the optional HTML alternative. */
export interface EmailBodyContent {
  htmlContent?: string | null;
  textContent?: string | null;
}

type SelectedEmailBody =
  { format: 'html' | 'text'; content: string } | { format: 'empty' };

function hasBodyContent(html: string): boolean {
  const template = document.createElement('template');
  template.innerHTML = html;
  // Metadata and styles do not constitute a readable email body.
  template.content
    .querySelectorAll('style, template, noscript')
    .forEach((node) => node.remove());
  return Boolean(
    template.content.textContent?.trim() ||
    template.content.querySelector('img, hr, video, audio'),
  );
}

/** Prefer usable, sanitized HTML; empty wrappers must not hide the text alternative. */
export function selectEmailBody(
  { htmlContent, textContent }: EmailBodyContent,
  cidMap?: Map<string, string>,
): SelectedEmailBody {
  if (htmlContent?.trim()) {
    const content = processEmailHtml({ html: htmlContent, cidMap });
    if (hasBodyContent(content)) return { format: 'html', content };
  }
  if (textContent?.trim()) return { format: 'text', content: textContent };
  return { format: 'empty' };
}
